import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import reducer from '../reducers'
import  {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
const  persistConfig = {
	key: 'root',
	storage,
	stateReconciler: autoMergeLevel2
}
const myPersistReducer = persistReducer(persistConfig, reducer)

const middleware = [thunkMiddleware]
if (process.env.NODE_ENV !== 'production') {
	middleware.push(createLogger())
}
/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
	myPersistReducer,
	composeEnhancers(applyMiddleware(...middleware))
)
export const persistor = persistStore(store)
export default store